import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'md' | 'lg';
};
export function CtaButton({
  children,
  href = '#oferta',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-10 py-4 text-sm md:text-base' : 'px-6 py-3 text-xs';
  return <a href={href} className={`cta-shine relative isolate inline-flex items-center justify-center overflow-hidden rounded-lg border border-gold/60 bg-[#152a5e] font-display font-bold uppercase tracking-[0.08em] text-cream shadow-[0_0_38px_-6px_rgba(37,73,150,0.9)] transition-[transform,background-color] duration-150 ease-out hover:bg-[#1b3673] hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft ${sizing} ${className}`} data-id="element-201" data-mp="20szexd3u47si">
      <span className="relative z-10" data-id="element-202" data-mp="137bt1m5097v8">{children}</span>
    </a>;
}